import React from "react"

const EkycCheckboxContent = ({ declarationParagraphs }) => {
  const myFunction = () => {
    var dots = document.getElementById("dots")
    var moreText = document.getElementById("more")
    var btnText = document.getElementById("myBtn")

    if (dots.style.display === "none") {
      dots.style.display = "inline"
      btnText.innerHTML = "Read more"
      moreText.style.display = "none"
    } else {
      dots.style.display = "none"
      btnText.innerHTML = "Read less"
      moreText.style.display = "inline"
    }
  }

  return (
    <>
      <label htmlFor="checkboxG6" className="css-label">
        <p>
          {" "}
          {declarationParagraphs?.para1} <span id="dots">...</span>
        </p>
        <span id="more">
          <p>
            {" "}
            {declarationParagraphs?.para2}{" "}
          </p>
          <p>
            {" "}
            {declarationParagraphs?.para3}{" "}
          </p>
          <p>
            {" "}
            {declarationParagraphs?.para4}{" "}
          </p>
        </span>
      </label>{" "}
      <span
        style={{ textDecoration: "underline" }}
        aria-hidden="true"
        onClick={myFunction}
        id="myBtn"
      >
        Read more
      </span>
      <p></p>
    </>
  )
}

export default EkycCheckboxContent
